module.exports = __webpack_public_path__ + "static/media/icon-floors.ac53a72c.svg";